<template>
    <div :class="`flyout-mask${this.show ? ' --show' : ''}`"
         @click="$emit('click')" />
</template>

<script>

export default {

    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_flyout-mask.scss

.flyout-mask {
    display: none;
    position: absolute;
    top: 0; bottom: -10px; left: 0; right: 0;
    margin: 0;
    z-index: z-index('dd-mask');

    @include bp-min-small {
        top: 0;
    }

    &.--show {
        display: block;

        @include bp-min-mid {
            display: none;
        }
    }
}

</style>
